import { useId, type TextareaHTMLAttributes, type ReactNode } from "react";
import { cn } from "../utils/cx.js";
import { Field } from "./Field.js";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: ReactNode;
  help?: ReactNode;
  error?: ReactNode;
  required?: boolean;
}

export function Textarea({
  label,
  help,
  error,
  required,
  id,
  className,
  value,
  defaultValue,
  ...rest
}: TextareaProps) {
  const auto = useId();
  const tid = id ?? auto;
  const invalid = error != null;

  const control = (
    <textarea
      id={tid}
      aria-invalid={invalid || undefined}
      className={cn(
        "min-h-16 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs outline-none transition-[color,box-shadow] field-sizing-content placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30",
        invalid && "border-destructive focus-visible:border-destructive focus-visible:ring-destructive/30",
        className,
      )}
      value={value as string | undefined}
      defaultValue={defaultValue as string | undefined}
      {...rest}
    />
  );

  if (label != null || help != null || error != null) {
    return (
      <Field label={label} required={required} help={help} error={error} htmlFor={tid}>
        {control}
      </Field>
    );
  }
  return control;
}
